import { render, staticRenderFns } from "./comps-radius.vue?vue&type=template&id=024cce70&scoped=true"
import script from "./comps-radius.vue?vue&type=script&lang=js"
export * from "./comps-radius.vue?vue&type=script&lang=js"
import style0 from "./comps-radius.vue?vue&type=style&index=0&id=024cce70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024cce70",
  null
  
)

export default component.exports